import React, { useState, useEffect, Fragment } from 'react';
import firstImage from '../images/primero.png';
import secondImage from '../images/segundo.png';
import thirdImage from '../images/tercero.png';
import { Link, useNavigate } from 'react-router-dom';
import TwoButtons from '../components/twoButtons';
import arrow from '../images/arrow-white.png';

const sortByMonth = (winegangs) => {
    winegangs.sort((a, b) => {
        if (b.month !== a.month) {
            return b.month - a.month;
        } else if (b.total_points !== a.total_points) {
            return b.total_points - a.total_points;
        } else {
            return b.last_batch_points - a.last_batch_points;
        }
    });
};
const sortByTotal = (winegangs) => {
    winegangs.sort((a, b) => {
        if (b.total_points !== a.total_points) {
            return b.total_points - a.total_points;
        } else if (b.month !== a.month) {
            return b.month - a.month;
        } else {
            return b.wines - a.wines;
        }
    });
};
const sortByWine = (winegangs) => {
    winegangs.sort((a, b) => {
        if (b.last_wine_points !== a.last_wine_points) {
            return b.last_wine_points - a.last_wine_points;
        } else if (b.last_batch_points !== a.last_batch_points) {
            return b.last_batch_points - a.last_batch_points;
        } else {
            return b.total_points - a.total_points;
        }
    });
};
const sortByTanda = (winegangs) => {
    winegangs.sort((a, b) => {
        if (b.last_batch_points !== a.last_batch_points) {
            return b.last_batch_points - a.last_batch_points;
        } else if (b.month !== a.month) {
            return b.month - a.month;
        } else {
            return b.total_points - a.total_points;
        }
    });
};
export default function Ranking() {
    const [winegangData, setWinegangData] = useState([]);
    const [selectedButton, setSelectedButton] = useState('General');
    const navigate = useNavigate();

    const fetchWinegangData = () => {
        const xhr = new XMLHttpRequest();
        const url = `${process.env.REACT_APP_API_URL}/winegangs`;
        //const url = `http://wineapi/api/winegangs`;

        xhr.open("GET", url, true);
        xhr.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    const winegangs = JSON.parse(this.responseText);

                    // Ordenar las winegangs por puntos en month de mayor a menor inicialmente
                    sortByTotal(winegangs);

                    setWinegangData(winegangs);
                    console.log("Datos de las winegangs:", winegangs);
                } else {
                    console.error("Error al obtener los datos de las winegangs:", this.status, this.responseText);
                }
            }
        };
        xhr.send();
    };

    useEffect(() => {
        fetchWinegangData();
    }, []);

    useEffect(() => {
        let sortedWinegangs = [...winegangData];
        if (selectedButton === 'Mensual') {
            sortByMonth(sortedWinegangs);
        } else if (selectedButton === 'General') {
            sortByTotal(sortedWinegangs);
        } else if (selectedButton === 'Tanda') {
            sortByTanda(sortedWinegangs);
        } else if (selectedButton === 'Vino') {
            sortByWine(sortedWinegangs);
        }
        setWinegangData(sortedWinegangs);
    }, [selectedButton]);

    const redirectToUserPage = (winegangId) => {
        navigate(`/gangs/${winegangId}`);
    };

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
    };
    const [hoveredDiv, setHoveredDiv] = useState(null);

    const handleMouseEnter = (divName) => {
        setHoveredDiv(divName);
    };

    const handleMouseLeave = () => {
        setHoveredDiv(null);
    };
    // El podio va siempre por el total, ordene como se ordene la tabla
    const podium = [...winegangData];
    sortByTotal(podium);

    return (
        <div className="winegangs-container">
            <div className="ranking-container">
                <h2>Clasificación</h2>
                <div className="row">
                    <div className="col-sm-4 ranking-second">
                        <img src={secondImage} alt="Segundo" className="ranking-image" />
                        {podium.length > 1 && (
                            <div>{podium[1].winegang_name} {podium[1].total_points}</div>
                        )}
                    </div>
                    <div className="col-sm-4 ranking-first">
                        <img src={firstImage} alt="Primero" className="ranking-image" />
                        {podium.length > 0 && (
                            <div>{podium[0].winegang_name} {podium[0].total_points}</div>
                        )}
                    </div>
                    <div className="col-sm-4 ranking-third">
                        <img src={thirdImage} alt="Tercero" className="ranking-image" />
                        {podium.length > 2 && (
                            <div>{podium[2].winegang_name} {podium[2].total_points}</div>
                        )}
                    </div>
                </div>
                
                <div className="main-table main-table-ranking-gangs">
                    {hoveredDiv === 'General' && <div className="hovered-info">Total de puntos</div>}
                    {hoveredDiv === 'Tanda' && <div className="hovered-info">Puntos del último evento</div>}
                    {hoveredDiv === 'Vino' && <div className="hovered-info">Puntos del último vino</div>}
                    <div className="ranking-row title-tab">
                        <div className="title">Pos.</div>
                        <div className="title">Equipos</div>
                        <div
                            className="title"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleButtonClick('General')}
                            onMouseEnter={() => handleMouseEnter('General')}
                            onMouseLeave={handleMouseLeave}
                        >   
                            {selectedButton === 'General' ? 'Total' : 'Total'}
                        </div>
                        <div
                            className="title"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleButtonClick('Tanda')}
                            onMouseEnter={() => handleMouseEnter('Tanda')}
                            onMouseLeave={handleMouseLeave}
                        >
                            {selectedButton === 'Tanda' ? 'Evento' : 'Evento'}
                        </div>
                        <div
                            className="title"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleButtonClick('Vino')}
                            onMouseEnter={() => handleMouseEnter('Vino')}
                            onMouseLeave={handleMouseLeave}
                        >
                            {selectedButton === 'Vino' ? 'Ult. Vino' : 'Ult. Vino'}
                        </div>
                        
                    </div>
                    <div className="ranking-row">
                        {winegangData.map((winegang, index) => (
                            <Fragment key={index}>
                                <div className="pos">{index + 1}</div>
                                <button className="item" onClick={() => redirectToUserPage(winegang.id)}>{winegang.winegang_name} ({winegang.members})</button>
                                <div className="item">{winegang.total_points}</div>
                                <div className="item">{winegang.last_batch_points}</div>
                                <div className="item">{winegang.last_wine_points}</div>
                            </Fragment>
                        ))}
                    </div>
                </div>
            </div>
            <TwoButtons />
        </div>
    );
}
